import React from "react";

function Contact() {
  return (
    <section className="content-section">
      <div className="glass-card contact-card">
        <h1>Contact</h1>
        <p>Du willst mit mir über Code, Ideen oder Projekte sprechen?</p>
        <a className="btn btn-primary" href="mailto:deinname@email.com">
          Schreib mir
        </a>
      </div>
    </section>
  );
}

export default Contact;
